import React from "react";
import styles from "./DropdownContent.module.css";

export const DropdownContent = (props) => {
    return (
        <div className={props.open ? styles.contentOpen : styles.contentClosed}>
            {props.open ? props.content : null}
        </div>
    );
}